document.addEventListener('DOMContentLoaded', function () {
  const openButtons = document.querySelectorAll('.full-nutrition-card-popup');
  const closeButtons = document.querySelectorAll('.full-nutrition-card__close');
  let overlay = document.querySelector('.overlay') || createOverlay();

  function createOverlay() {
    const overlayElement = document.createElement('div');
    overlayElement.className = 'overlay';
    document.body.appendChild(overlayElement);
    return overlayElement;
  }

  function initializeAccordions(popup) {
    if (!popup) return;

    const accordionItems = popup.querySelectorAll('.accordion__item');
    accordionItems.forEach((item) => {
      const summary = item.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          accordionItems.forEach((otherItem) => {
            if (otherItem !== item && otherItem.hasAttribute('open')) {
              otherItem.removeAttribute('open');
            }
          });
          item.toggleAttribute('open');
        });
      }
    });
  }

  function openPopup(button) {
    if (!button) return;

    const productId = button.dataset.productId;
    const targetPopup = document.getElementById(`full-nutrition-card-${productId}`);
    if (targetPopup) {
      overlay.classList.add('active');
      targetPopup.classList.add('active');
      document.body.classList.add('body-no-scroll');
      initializeAccordions(targetPopup);
    }
  }

  function closePopup() {
    const activePopup = document.querySelector('.full-nutrition-popup.active');
    if (activePopup) {
      overlay.classList.remove('active');
      activePopup.classList.remove('active');
      setTimeout(() => {
        document.body.classList.remove('body-no-scroll');
      }, 200);
    }
  }

  if (openButtons.length > 0) {
    openButtons.forEach((button) => {
      button.addEventListener('click', () => openPopup(button));
    });
  }

  if (closeButtons.length > 0) {
    closeButtons.forEach((button) => {
      button.addEventListener('click', closePopup);
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }
});